import type { QueryClient, QueryKey } from "@tanstack/react-query";

const isProductDetailKey = (key: QueryKey): boolean => {
  const first = key[0];
  if (!first || typeof first !== "object") return false;
  const endpoint = (first as { endpoint?: unknown }).endpoint;
  return typeof endpoint === "string" && endpoint.startsWith("/api/gvads/productid/");
};

export const invalidateProductQueries = (queryClient: QueryClient) => {
  void queryClient.invalidateQueries({ queryKey: [{ entity: "V4ProductReportByProduct" }] });
  void queryClient.invalidateQueries({ queryKey: [{ entity: "V4ProductReportByGrouping" }] });
  void queryClient.invalidateQueries({ queryKey: [{ entity: "V4ProductReportOptions" }] });
  void queryClient.invalidateQueries({ queryKey: [{ entity: "V4ProductAds" }] });
  void queryClient.invalidateQueries({ queryKey: ["products"] });
  void queryClient.invalidateQueries({ queryKey: ["product_report"] });
  void queryClient.invalidateQueries({
    predicate: (query) => isProductDetailKey(query.queryKey),
  });
};
